<template>
    <div class="lineManagements">
        <div class="lineQuery">
            <a-input placeholder="请输入查询关键字" style="width:200px" v-model="searchForm.keyword" />
            <a-select placeholder="请选择状态" style="width:200px" v-model="searchForm.status">
                <a-select-option value="0">完好</a-select-option>
                <a-select-option value="1">故障</a-select-option>
                <a-select-option value="2">缺失</a-select-option>
            </a-select>
            <a-select placeholder="请选择排序" style="width:200px" v-model="searchForm.orderType" @change="typeChange">
                <a-select-option value="1">维保时间降序</a-select-option>
                <a-select-option value="2">维保时间升序</a-select-option>
            </a-select>
            <a-select v-if="searchForm.buildingId" v-model="searchForm.layer" style="width:200px" placeholder="请选择楼层">
                <a-select-option v-for="item in layerNum" :key="item" :value="item">
                    {{ item }}
                </a-select-option>
            </a-select>
            <a-button style="margin:0 10px;" type="primary" @click="search">查询</a-button>
            <a-button @click="reset">重置</a-button>
            <a-button type="primary" style="float: right;margin-left: 10px;" @click="batchEdit">批量修改</a-button>
        </div>
        <CustomPage :isRowSelection="true" :columns="columns" :url="url" ref="table">
            <template slot="format1" slot-scope="scope" v-if="scope.record.location">
                <a-tooltip>
                    <template slot='title'>
                        {{scope.record.location}}
                    </template>
                    {{scope.record.location&&scope.record.location.replace(/(.{40})(.*)/,'$1...')||'--'}}
                </a-tooltip>
            </template>
            <template slot="format3" slot-scope="scope">
               <a-tag v-if="scope.record.status == '0' " color="green">完好</a-tag>
               <a-tag v-if="scope.record.status == '1' " color="orange">故障</a-tag>
               <a-tag v-if="scope.record.status == '2' " color="red">缺失</a-tag>
            </template>
            <template slot="format2" slot-scope="scope">
                <a-icon type="edit" theme="twoTone" twoToneColor="#4a9ff5" @click="edit(scope.record)" title="修改"></a-icon>
                &nbsp;
                <a-icon type="delete" theme="twoTone" twoToneColor="#42b983" @click="del(scope.record)" title="删除"></a-icon>
            </template>
        </CustomPage>
        <!-- 添加、修改-->
        <FireFacilityAdd :visibleEdit="dialog" @close="dialog=false" @success="dialog=false,search();" ref="dialog"></FireFacilityAdd>
        <!--批量修改-->
        <FireFacilityEdit :visibleEdit="dialog2" @close="dialog2=false" @success="dialog2=false,search();" ref="dialog2"></FireFacilityEdit>
    </div>
</template>

<script>
import CustomPage from '@/views/common/CustomPage'
import FireFacilityAdd from './FireFacilityAdd'
import FireFacilityEdit from './FireFacilityEdit'

const table = {
  searchForm: {
    keyword: '',
    status: undefined,
    facilityType: undefined,
    buildingId: undefined,
    campus: undefined,
    layer: undefined,
    orderType: undefined,
  },
  url: 'facility/page',
  columns: [
    {
      title: '校区',
      align: 'center',
      dataIndex: 'campus_text'
    },{
    title: '建筑物',
    align: 'center',
    dataIndex: 'buildingName'
  },
  {
    title: '层数',
    align: 'center',
    dataIndex: 'layer'
  },
  {
    title: '方位',
    align: 'center',
    dataIndex: 'orient_text'
  }, {
    title: '详细位置',
    align: 'center',
    dataIndex: 'locationRemark',
    scopedSlots: {
      customRender: 'format1'
    }
  },
  {
    title: '设施编号',
    align: 'center',
    dataIndex: 'facilityNum'
  },
  {
    title: '设施类型',
    align: 'center',
    dataIndex: 'facilityTypeName'
  },
  {
    title: '每组数量',
    align: 'center',
    dataIndex: 'groupNum'
  },
  {
    title: '安装时间',
    align: 'center',
    dataIndex: 'instime',
    customRender: (text, row, index) => {
      return text ? text.slice(0, 10) : ' -- '
    }
  },
  {
    title: '上次维保时间',
    align: 'center',
    dataIndex: 'checkTime',
    customRender: (text, row, index) => {
      return text ? text.slice(0, 10) : ' -- '
    }
  },
  {
    title: '巡查时间',
    align: 'center',
    dataIndex: 'lastmaint',
    customRender: (text, row, index) => {
      return text ? text.slice(0, 10) : ' -- '
    }
  },
  {
    title: '状态',
    align: 'center',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'format3'
    }
  },
  {
    title: '二维码编号',
    align: 'center',
    dataIndex: 'qrcode'
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'action',
    scopedSlots: {
      customRender: 'format2'
    },
    width: 150
  }

  ]
}

export default {
  components: {
    CustomPage,
    FireFacilityAdd,
    FireFacilityEdit
  },
  data () {
    return {
      dialog: false,
      dialog2:false,
      ...table,
      loading: false,
      form: this.$form.createForm(this),
      layer: '',
      layerNum: [], // 层数
      isKeyword:false,
      isOrderType:false
    }
  },
  mounted () {


  },
  methods: {
    search () {
      this.loading = true
      this.searchForm.pageNum = 1 // 初始化的当前页
      this.$refs.table.handleList(this.searchForm)
      this.loading = false
    },
    add () {
      	this.$refs.dialog.init()
      	this.dialog = true
    },
    // 修改设施
    edit (record) {
      this.dialog = true
      record.facilityOrBuilding = 1
      this.$refs.dialog.setFormValues(record)
    },
    //批量修改
    batchEdit(){
      if(this.$refs.table.getSelectedRows().length <1){
        this.$message.error('请选择需删除的数据')
        return;
      }
    	this.dialog2 = true
    	var id=[],rows=this.$refs.table.getSelectedRows();
    	for(var i=0;i<rows.length;i++){
    		id.push(rows[i].id)
    	}
    	this.$refs.dialog2.setFormValues(id)
    },
    del (record) {
      let that = this
      that.$confirm({
        maskClosable: true,
        title: '删除',
        content: '确定删除 ' + record.facilityNum + ' 吗?',
        onOk () {
          that.$delete('facility/delete/' + record.id).then((r) => {
            that.$message.success('操作成功')
            that.search()
          })
        },
        onCancel () {}
      })
    },
    batchDel () {
      let that = this
      if(that.$refs.table.getSelectedRows().length <1){
        that.$message.error('请选择需删除的数据')
        return;
      }
      that.$confirm({
        maskClosable: true,
        title: '删除',
        content: '确定删除所选数据?',
        onOk () {
          var id=[],rows=that.$refs.table.getSelectedRows();
          for(var i=0;i<rows.length;i++){
          	id.push(rows[i].id)
          }
          that.$delete('facility/delete/' + id).then((r) => {
            that.$message.success('操作成功')
            that.search()
          })
        },
        onCancel () {}
      })
    },
    typeChange(){
      this.search()
    },
    // 重置
    reset () {
      this.searchForm.keyword= '';
      this.searchForm.status= undefined;
      this.searchForm.facilityType= undefined;
      this.searchForm.campus= undefined;
      this.searchForm.layer= undefined;
      this.searchForm.orderType= undefined;
      this.search()
    },
    setFormValues(id){
      this.searchForm.buildingId = id
      this.$get('building/getBuildingById',{id:id}).then(r => {
        this.layerNum = r.data.buildingLayer.split(",");
      })
      this.search()
    },
    equipment(data){
    	if(data.currentKey!=null){
    		this.searchForm.status=data.currentKey;
    		this.isOrderType=true;
    	}else{
    		this.isOrderType=false;
    		this.searchForm.status=undefined;
    	}
      this.setFormValues(data.buildingId);
    	this.isKeyword=true;
    	this.searchForm.keyword= data.typename;
    	this.search()
    }
  }
}
</script>

<style lang="less">
    .lineManagements {
        width: 100%;

        .lineQuery {
            margin: 10px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/web/firefacility/FireFacilityMap.vue